import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {Validators} from "@angular/forms";
import {Contact} from "../../company/company.model";
import {FormComponent} from "../form.component";

@Component({
    selector: 'app-user-profile-form',
    templateUrl: './user-profile-form.component.html',
    styleUrls: [],
    standalone: false
})
export class UserProfileFormComponent extends FormComponent<Contact> implements OnInit {
  @Input() profile?: Contact;
  @Input() isOwnProfile = false;
  @Input() disabled = false;
  @Input() submitButtonLabel = 'app_update';

  permissionOptions = [
    { label: this.i18next.t('contact_mypascom_account_enabled_label'), value: 'enabled' },
    { label: this.i18next.t('contact_mypascom_account_admin_label'), value: 'admin' },
  ];

  ngOnInit() {
    if (!!this.profile?.id) {
      this.permissionOptions = [
        { label: this.i18next.t('contact_mypascom_account_disabled_label'), value: 'disabled' },
        ...this.permissionOptions,

      ]
    }
    super.ngOnInit();
  }

  protected createForm() {
    this.form = this.fb.group({
      first_name: [{value: this.profile?.first_name ?? "", disabled: this.disabled}, Validators.required],
      last_name: [{value: this.profile?.last_name ?? "", disabled: this.disabled}, Validators.required],
      email: [{value: this.profile?.email ?? "", disabled: this.disabled}, Validators.required],
      mypascom_account: [{value: this.profile?.mypascom_account ?? "enabled", disabled: this.isOwnProfile || this.disabled}, Validators.required],
    });
  }
}
